import { Children, cloneElement, useCallback, useEffect, useRef } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const GOOGLE_MAPS_LIBRARIES = ["places"];

const assignRef = (ref, node) => {
  if (!ref) return;
  if (typeof ref === "function") {
    ref(node);
    return;
  }
  ref.current = node;
};

export const PlacesAutocomplete = ({ children, restrictions }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
    language: "es",
  });

  const inputRef = useRef(null);
  const child = Children.only(children);
  const childRef = useRef(child.ref);
  const country = restrictions?.country;
  childRef.current = child.ref;

  const setInputRef = useCallback((node) => {
    inputRef.current = node;
    assignRef(childRef.current, node);
  }, []);

  useEffect(() => {
    if (!isLoaded || !inputRef.current || !window.google?.maps?.places) {
      return undefined;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      country ? { restrictions: { country } } : undefined
    );

    return () => {
      window.google?.maps?.event?.clearInstanceListeners(autocomplete);
    };
  }, [isLoaded, country]);

  return cloneElement(child, { ref: setInputRef });
};
